import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

/** Visual state of a step in a stepper. */
export type StepState = "done" | "current" | "upcoming";

interface StepCircleProps {
  /** 1-indexed step number, shown for `current`/`upcoming` states. */
  n: number;
  state: StepState;
  className?: string;
}

/**
 * Circled step indicator shared by the deal-registration wizard
 * (DealRegistrationWizard) and the onboarding stepper (OnboardingShell).
 * `done`/`current` get the filled coral badge; `upcoming` gets an outlined
 * neutral badge. Completed steps show a check instead of the number.
 * (CHP-500 — replaces the plain `{n}.` onboarding numbering with the deal
 * wizard's circled-number style and removes the duplicate inline markup.)
 */
export function StepCircle({ n, state, className }: StepCircleProps) {
  return (
    <span
      className={cn(
        "flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
        state === "upcoming"
          ? "border bg-background text-muted-foreground"
          : "bg-primary text-primary-foreground",
        className,
      )}
    >
      {state === "done" ? <Check className="h-4 w-4" aria-hidden /> : n}
    </span>
  );
}
